export const CommonConsulateCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Regione',
    path: '/sistema/geografiche/italia/regione',
  },
];
